/* eslint-disable complexity */
/* eslint-disable no-magic-numbers */

export default (/* context */) => ({
	pluralizationRules: {
		/**
		 * Usage:
		 * "0 баллов | (\d+)1 балл | (\d+)[2-4] балла | (\d+)[10-19] (много) баллов"
		 * "{points} баллов | {points} балл | {points} балла | {points} баллов"
		 *
		 * @param choice {number} a choice index given by the input to $tc:
		 * `$tc('path.to.rule', choiceIndex)`
		 * @param choicesLength {number} an overall amount of available choices
		 * @returns a final choice index to select plural word by
		 */
		ru(choice, choicesLength) {
			// this === VueI18n instance, so the locale property also exists here

			if (choice === 0) {
				return 0;
			}

			const lastDigit = choice % 10;
			const last2Digits = choice % 100;

			const teen = last2Digits > 10 && last2Digits < 20;
			const endsWithOne = lastDigit === 1;

			if (choicesLength < 4) {
				return !teen && endsWithOne ? 1 : 2;
			}
			if (!teen && endsWithOne) {
				return 1;
			}
			if (!teen && lastDigit >= 2 && lastDigit <= 4) {
				return 2;
			}

			return 3;
		},
	},
});
